// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_PreferencesPanel.scss
// module id = 638
// module chunks = 37 88